<template>
  <div v-show="active">
    <UtilListingVideo v-if="isVideo" :file="item" class="w-full aspect-video" />
    <UtilImgBackground v-else-if="isImage" :url="formatImgixUrl(item)" class="w-full h-full bg-contain" />
    <UtilImgBackground v-else-if="item.src" :url="item.src" class="w-full h-full !bg-contain" />
  </div>
</template>

<script>
import UtilListingVideo from './UtilListingVideo.vue'
import UtilImgBackground from './UtilImgBackground.vue'
import { formatMapImageUrl, formatImgixUrl, getFileType } from '@/lib/file/file'

export default {
  name: 'UtilListingGalleryItem',
  components: {
    UtilListingVideo,
    UtilImgBackground
  },
  props: {
    item: { type: Object },
    active: { type: Boolean }
  },
  data() {
    return {
      helpers: {
        hasBeenActive: false
      },
      formatMapImageUrl,
      formatImgixUrl
    }
  },
  computed: {
    type() {
      return getFileType(this.item)
    },
    showItem() {
      return this.helpers.hasBeenActive
    },
    isVideo() {
      return this.type && this.type.includes('video')
    },
    isImage() {
      return this.type && this.type.includes('image')
    }
  },
  watch: {
    active: {
      immediate: true,
      handler() {
        this.onActiveChange()
      }
    }
  },
  methods: {
    onActiveChange() {
      if (this.active) {
        this.helpers.hasBeenActive = true
      }
    }
  },
  mounted() {
    this.onActiveChange()
  }
}
</script>
